import * as React from 'react';
import { useState } from 'react';

export interface BreadcrumbsContext {
    breadcrumbs: string[];
    setBreadcrumbs: React.Dispatch<React.SetStateAction<string[]>>;
}

const initState: BreadcrumbsContext = {
    breadcrumbs: [],
    setBreadcrumbs: () => {},
};

const breadcrumbsContext = React.createContext<BreadcrumbsContext>(initState);

export function BreadcrumbsProvider(props: Readonly<{ children: React.ReactNode }>): React.ReactElement {
    const [breadcrumbs, setBreadcrumbs] = useState<string[]>([]);

    return (
        <breadcrumbsContext.Provider value={{ breadcrumbs: breadcrumbs, setBreadcrumbs: setBreadcrumbs }}>
            {props.children}
        </breadcrumbsContext.Provider>
    );
}

export function useBreadcrumbsContext() {
    return React.useContext(breadcrumbsContext);
}
